import React, { useState, useRef, useEffect } from "react";
import NewFooter from "../Footer/NewFooter";
import NewHeader from "../Header/NewHeader";
import { SlArrowRight } from "react-icons/sl";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const Details = () => {
  const [activeStep, setActiveStep] = useState(1);

  const sectionsRef = useRef([]);

  const addToRefs = (el) => {
    if (el && !sectionsRef.current.includes(el)) {
      sectionsRef.current.push(el);
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    const stepSections = sectionsRef.current.filter(
      // eslint-disable-next-line
      (section) => section.dataset.step == activeStep
    );

    stepSections.forEach((section) => {
      const texts = section.querySelectorAll("p, h2, a, span, div, button");
      gsap.fromTo(
        texts,
        { opacity: 0, y: 50 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          stagger: 0.2,
          ease: "power2.out",
        }
      );

      const images = section.querySelectorAll("img");
      images.forEach((img) => {
        gsap.fromTo(
          img,
          { opacity: 0, y: 50 },
          {
            opacity: 1,
            y: 0,
            duration: 1.2,
            ease: "power2.out",
          }
        );
      });
    });
  }, [activeStep]);

  return (
    <div className="overflow-x-hidden">
      {/* header */}
      {/* <header className="hidden lg:block fixed top-0 left-0 w-full z-20 bg-transparent">
        <div className="max-w-[1600px] mx-auto flex items-center justify-between py-4 px-10 xl:px-20 2xl:px-32">
          <a href="/HomePage">
          <img
            src="../assets/Logo2.png"
            alt="Logo"
            className="h-10 cursor-pointer"
          /></a>

          <div className="flex items-start space-x-16">
            <nav className="flex flex-col text-[13px] tracking-[0.3em] text-[#948A78] uppercase space-y-5">
              <a href ="/OurPhilosophy">Our Philosophy</a>
              <a href ="/OurSpaces">Our Spaces</a>
              <a href ="/OurServices">Our Services</a>
            </nav>

            <a
              href="/BookNow"
              className="hidden lg:inline-block px-3 py-0 text-[13px] text-[#4F423B] tracking-[0.3em] uppercase mt-[1px]">
              Book Now!
            </a>
          </div>
        </div>
      </header> */}
      <NewHeader />

      <div className="hidden md:flex w-full bg-[#f5f2f0] pt-40 pb-20 justify-center">
        <div className="max-w-6xl w-full flex items-center justify-between px-4">
          <button
            className={`uppercase flex items-center justify-center gap-2 tracking-[0.3em] ${
              activeStep === 1 ? "text-[#948A78]" : "text-[#BFB5A3]"
            }`}
            onClick={() => setActiveStep(1)}
          >
            guest details
          </button>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 160 25"
            className="w-24 h-10"
          >
            <path
              d="M10 12.5H159M159 12.5l-8-8M159 12.5l-8 8"
              stroke="#948A78"
              strokeWidth="1.5"
              fill="none"
            />
          </svg>

          <button
            className={`uppercase flex items-center justify-center gap-2 tracking-[0.3em] ${
              activeStep === 2 ? "text-[#948A78]" : "text-[#BFB5A3]"
            }`}
            onClick={() => setActiveStep(2)}
          >
            payment
          </button>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 160 25"
            className="w-24 h-10"
          >
            <path
              d="M10 12.5H159M159 12.5l-8-8M159 12.5l-8 8"
              stroke="#948A78"
              strokeWidth="1.5"
              fill="none"
            />
          </svg>

          <button
            className={`uppercase flex items-center justify-center gap-2 tracking-[0.3em] ${
              activeStep === 3 ? "text-[#948A78]" : "text-[#BFB5A3]"
            }`}
            onClick={() => setActiveStep(3)}
          >
            confirmation
          </button>
        </div>
      </div>

      <div className="block sm:block md:hidden bg-[#f5f2f0] pt-44 pb-20 px-6">
        <div className="grid grid-cols-[auto,auto,auto,auto,auto] items-center gap-0 justify-center">
          <button
            className={`uppercase text-[13px] text-center whitespace-nowrap ${
              activeStep === 1 ? "text-[#948A78]" : "text-[#BFB5A3]"
            }`}
            onClick={() => setActiveStep(1)}
          >
            guest details
          </button>

          <SlArrowRight className="text-[#BFB5A3] text-sm mx-2 justify-self-center" />

          <button
            className={`uppercase text-[13px] text-center whitespace-nowrap ${
              activeStep === 2 ? "text-[#948A78]" : "text-[#BFB5A3]"
            }`}
            onClick={() => setActiveStep(2)}
          >
            payment
          </button>

          <SlArrowRight className="text-[#BFB5A3] text-sm mx-2 justify-self-center" />

          <button
            className={`uppercase text-[13px] text-center whitespace-nowrap ${
              activeStep === 3 ? "text-[#948A78]" : "text-[#BFB5A3]"
            }`}
            onClick={() => setActiveStep(3)}
          >
            confirmation
          </button>
        </div>
      </div>

      {activeStep === 1 && (
        <>
          <div className="max-w-[1400px] mx-auto px-6 lg:px-20">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
              {/* leptop */}
              <div
                ref={addToRefs}
                data-step={1}
                className="hidden lg:block mt-32 space-y-10 xl:px-24 lg:px-5"
              >
                <div className="flex items-center justify-between">
                  <p className="text-[#948A78] text-[20px]">Dates</p>
                  <p className="text-[#948A78] tracking-[0.25em] uppercase text-[13px]">
                    3 September – 10 September
                  </p>
                </div>

                <div className="flex items-center justify-between">
                  <p className="text-[#948A78] text-[20px]">Guests</p>
                  <p className="text-[#948A78] tracking-[0.25em] uppercase text-[13px] mr-44">
                    2&nbsp;Guests
                  </p>
                </div>

                <a
                  href="/BookNow"
                  className="tracking-[0.13em] uppercase text-[#948A78] text-[13px] lg:ml-60 xl:ml-[50vh] 2xl:ml-[25vh]
                hover:font-bold underline decoration-[#948A78] underline-offset-[10px] decoration-1 hover:underline-offset-[5px] transition-all duration-300"
                >
                  Edit&nbsp;Details
                </a>
              </div>
              {/* mobile */}
              <div
                ref={addToRefs}
                data-step={1}
                className="lg:hidden mt-10 flex flex-col items-center space-y-20 w-full max-w-sm mx-auto"
              >
                <div className="flex items-center justify-start w-full gap-6">
                  <p className="text-[#948A78] text-[20px]">Dates</p>
                  <span className="text-[#948A78] tracking-[0.2em] uppercase text-[13px]">
                    3 September To 10 September
                  </span>
                </div>

                <div className="flex items-center justify-start w-full gap-6">
                  <p className="text-[#948A78] text-[20px]">Guests</p>
                  <span className="text-[#948A78] tracking-[0.2em] uppercase text-[13px]">
                    2 Guests
                  </span>
                </div>

                <a
                  href="/BookNow"
                  className="tracking-[0.13em] uppercase text-[#948A78] text-[12px] self-start ml-20 hover:font-bold underline decoration-[#948A78] underline-offset-[12px] decoration-1 hover:underline-offset-[5px] transition-all duration-300"
                >
                  Edit Details
                </a>
              </div>

              <div
                ref={addToRefs}
                data-step={1}
                className="hidden lg:flex justify-end overflow-hidden"
              >
                <img
                  src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/feedbd35-5f4e-43a6-9d88-536119619600/public" //Tao_details.webp
                  alt="img 1"
                  className="w-[70vh] h-[50vh] xl:w-[80vh] xl:h-[60vh] 2xl:h-[45vh] object-cover"
                />
              </div>
            </div>

            <div className="h-32"></div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 pb-40">
              <div
                ref={addToRefs}
                data-step={1}
                className="hidden lg:flex gap-10"
              >
                <div className="text-right">
                  <p className="text-[#948A78] text-[20px] xl:ml-5 lg:-ml-5">
                    Enter&nbsp;your
                    <br />
                    Details
                  </p>
                </div>

                <div className="space-y-8 w-[350px] mt-14 lg:-ml-10 xl:ml-3">
                  <div>
                    <input
                      type="text"
                      placeholder="First Name"
                      className="w-full bg-transparent outline-none text-[#948A78] text-[13px] uppercase tracking-[0.3em] placeholder-[#B5AC9E]"
                    />
                    <div className="border-b border-[#877D6F]"></div>
                  </div>

                  <div>
                    <input
                      type="text"
                      placeholder="Last Name"
                      className="w-full bg-transparent outline-none text-[#948A78] text-[13px] uppercase tracking-[0.3em] placeholder-[#B5AC9E]"
                    />
                    <div className="border-b border-[#877D6F]"></div>
                  </div>

                  <div>
                    <input
                      type="tel"
                      placeholder="Mobile"
                      className="w-full bg-transparent outline-none text-[#948A78] text-[13px] uppercase tracking-[0.3em] placeholder-[#B5AC9E]"
                    />
                    <div className="border-b border-[#877D6F]"></div>
                  </div>

                  <div>
                    <input
                      type="email"
                      placeholder="Email ID"
                      className="w-full bg-transparent outline-none text-[#948A78] text-[13px] uppercase tracking-[0.3em] placeholder-[#B5AC9E]"
                    />
                    <div className="border-b border-[#877D6F]"></div>
                  </div>

                  <div>
                    <textarea
                      placeholder="Special Request"
                      className="w-full bg-transparent outline-none text-[#948A78] text-[13px] uppercase tracking-[0.3em] placeholder-[#B5AC9E]"
                    />
                    <div className="border-b border-[#877D6F] mt-20 mb-5"></div>
                  </div>

                  <button
                    onClick={() => setActiveStep(2)}
                    className="tracking-[0.25em] text-[13px] uppercase text-[#948A78] ml-40
                    hover:font-bold underline decoration-[#948A78] underline-offset-[10px] decoration-1 hover:underline-offset-[5px] transition-all duration-300"
                  >
                    Submit&nbsp;&&nbsp;Continue
                  </button>
                </div>
              </div>

              <div
                ref={addToRefs}
                data-step={1}
                className="flex flex-col items-center justify-center min-h-screen px-4 lg:hidden"
              >
                <div className="mb-2 text-right">
                  <p className="text-[#948A78] text-[20px] sm:mr-[50vh] mr-[42vh]">
                    Guest
                    <br />
                    Details
                  </p>
                </div>

                <div className="space-y-8 w-full max-w-[260px] ml-14">
                  <div>
                    <input
                      type="text"
                      placeholder="First Name"
                      className="w-full bg-transparent outline-none text-[#948A78] text-[13px] uppercase tracking-[0.3em] placeholder-[#B5AC9E]"
                    />
                    <div className="border-b border-[#877D6F]"></div>
                  </div>

                  <div>
                    <input
                      type="text"
                      placeholder="Last Name"
                      className="w-full bg-transparent outline-none text-[#948A78] text-[13px] uppercase tracking-[0.3em] placeholder-[#B5AC9E]"
                    />
                    <div className="border-b border-[#877D6F]"></div>
                  </div>

                  <div>
                    <input
                      type="tel"
                      placeholder="Mobile"
                      className="w-full bg-transparent outline-none text-[#948A78] text-[13px] uppercase tracking-[0.3em] placeholder-[#B5AC9E]"
                    />
                    <div className="border-b border-[#877D6F]"></div>
                  </div>

                  <div>
                    <input
                      type="email"
                      placeholder="Email ID"
                      className="w-full bg-transparent outline-none text-[#948A78] text-[13px] uppercase tracking-[0.3em] placeholder-[#B5AC9E]"
                    />
                    <div className="border-b border-[#877D6F]"></div>
                  </div>

                  <div>
                    <textarea
                      placeholder="Special Request"
                      className="w-full bg-transparent outline-none text-[#948A78] text-[13px] uppercase tracking-[0.3em] placeholder-[#B5AC9E]"
                    />
                    <div className="border-b border-[#877D6F] mt-20 mb-5"></div>
                  </div>

                  <button
                    onClick={() => setActiveStep(2)}
                    className="tracking-[0.25em] text-[13px] uppercase text-[#948A78] w-full text-left hover:font-bold underline decoration-[#948A78] underline-offset-[12px] decoration-1 hover:underline-offset-[5px] transition-all duration-300"
                  >
                    Submit&nbsp;&&nbsp;Continue
                  </button>
                </div>
              </div>

              <div ref={addToRefs} data-step={1} className="hidden lg:block">
                <p className="text-[#948A78] text-[20px] mb-6 text-right xl:mr-[70vh] lg:mr-[50vh]">
                  Pricing <br /> Details
                </p>

                <div className="text-[13px] tracking-[0.2em] text-[#948A78] space-y-4 pl-32">
                  <div className="grid grid-cols-2 w-[300px]">
                    <p>Rs xx × 1 night</p>
                    <p className="text-right">Rs xx</p>
                  </div>

                  <div className="grid grid-cols-2 w-[300px]">
                    <p>GST @ 12%</p>
                    <p className="text-right">Rs xx</p>
                  </div>

                  <div className="grid grid-cols-2 w-[300px]">
                    <p>Convenience Fee</p>
                    <p className="text-right">Rs xx</p>
                  </div>

                  <div className="pt-6">
                    <div className="grid grid-cols-2 w-[300px] uppercase font-bold tracking-[0.3em]">
                      <p>Total Cost</p>
                      <p className="text-right">Rs xx</p>
                    </div>

                    <p className="text-[13px] tracking-[0.25em] mt-8 xl:ml-[35vh] lg:ml-60 2xl:ml-60">
                      Rs&nbsp;xx
                      <br />
                      per&nbsp;person
                    </p>
                  </div>
                </div>
              </div>

              <div
                ref={addToRefs}
                data-step={1}
                className="block lg:hidden text-left px-8"
              >
                <p className="text-[#948A78] text-[20px] mb-6 sm:ml-[15vh] -ml-[8vh]">
                  Pricing
                  <br />
                  Details
                </p>

                <div className="text-[13px] tracking-[0.2em] text-[#948A78] space-y-4 ml-10">
                  <div className="grid grid-cols-2 w-full max-w-xs mx-auto">
                    <p>Rs xx X 1 night</p>
                    <p className="text-right">Rs xx</p>
                  </div>

                  <div className="grid grid-cols-2 w-full max-w-xs mx-auto">
                    <p>GST @ 12%</p>
                    <p className="text-right">Rs xx</p>
                  </div>

                  <div className="grid grid-cols-2 w-full max-w-xs mx-auto">
                    <p>Convenience Fee</p>
                    <p className="text-right">Rs xx</p>
                  </div>

                  <div className="pt-6">
                    <div className="grid grid-cols-2 w-full max-w-xs mx-auto uppercase font-bold tracking-[0.3em]">
                      <p>Total Cost</p>
                      <p className="text-right">Rs xx</p>
                    </div>

                    <div className="grid grid-cols-2 w-full max-w-xs mx-auto mt-8">
                      <div />
                      <p className="justify-self-end text-[13px] -mr-10 tracking-[0.25em] text-[#948A78]">
                        Rs&nbsp;xx
                        <br />
                        per&nbsp;person
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {/* ---------------- Payment PAGE---------------- */}
      {activeStep === 2 && (
        <div className="max-w-[1400px] mx-auto px-6 lg:px-20">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
            {/* leptop */}
            <div
              ref={addToRefs}
              data-step={2}
              className="hidden lg:block mt-32 space-y-10 xl:px-24 lg:px-5"
            >
              <div className="flex items-center justify-between">
                <p className="text-[#948A78] text-[20px]">Dates</p>
                <p className="text-[#948A78] tracking-[0.25em] uppercase text-[13px]">
                  3 September – 10 September
                </p>
              </div>

              <div className="flex items-center justify-between">
                <p className="text-[#948A78] text-[20px]">Guests</p>
                <p className="text-[#948A78] tracking-[0.25em] uppercase text-[13px] mr-44">
                  2&nbsp;Guests
                </p>
              </div>

              <a
                href="/Details"
                className="tracking-[0.13em] uppercase text-[#948A78] text-[13px] lg:ml-60 xl:ml-[50vh] 2xl:ml-[25vh]
              hover:font-bold underline decoration-[#948A78] underline-offset-[10px] decoration-1 hover:underline-offset-[5px] transition-all duration-300"
              >
                Edit&nbsp;Details
              </a>
            </div>
            {/* mobile */}
            <div
              ref={addToRefs}
              data-step={2}
              className="lg:hidden mt-10 flex flex-col items-center space-y-20 w-full max-w-sm mx-auto"
            >
              <div className="flex items-center justify-start w-full gap-6">
                <p className="text-[#948A78] text-[20px]">Dates</p>
                <span className="text-[#948A78] tracking-[0.2em] uppercase text-[13px]">
                  3 September To 10 September
                </span>
              </div>

              <div className="flex items-center justify-start w-full gap-6">
                <p className="text-[#948A78] text-[20px]">Guests</p>
                <span className="text-[#948A78] tracking-[0.2em] uppercase text-[13px]">
                  2 Guests
                </span>
              </div>

              <a
                href="/Details"
                className="tracking-[0.13em] uppercase text-[#948A78] text-[12px] self-start ml-20
              hover:font-bold underline decoration-[#948A78] underline-offset-[12px] decoration-1 hover:underline-offset-[5px] transition-all duration-300"
              >
                Edit Details
              </a>
            </div>

            <div
              ref={addToRefs}
              data-step={2}
              className="hidden lg:flex justify-end overflow-hidden"
            >
              <img
                src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/feedbd35-5f4e-43a6-9d88-536119619600/public" //Tao_details.webp
                alt="img 2"
                className="w-[70vh] h-[50vh] xl:w-[80vh] xl:h-[60vh] 2xl:h-[45vh] object-cover"
              />
            </div>
          </div>

          <div className="h-32"></div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 pb-40">
            <div
              ref={addToRefs}
              data-step={2}
              className="hidden lg:flex gap-10"
            >
              <div className="text-right">
                <p className="text-[#948A78] text-[20px] xl:ml-5 lg:-ml-5">
                  Payment
                  <br />
                  Details
                </p>
              </div>

              <div className="space-y-8 w-[350px] mt-14 lg:-ml-10 xl:ml-3">
                <div>
                  <select
                    defaultValue=""
                    className="w-full bg-transparent outline-none text-[#948A78] text-[13px] uppercase tracking-[0.3em] placeholder-[#B5AC9E]"
                  >
                    <option value="" disabled className="text-[#B5AC9E]">
                      Pay With
                    </option>
                    <option value="card">Credit / Debit Card</option>
                    <option value="upi">UPI</option>
                    <option value="netbanking">Net Banking</option>
                    <option value="cash">Cash</option>
                  </select>

                  <div className="border-b border-[#877D6F]"></div>
                </div>

                <div>
                  <input
                    type="tel"
                    placeholder="number"
                    className="w-full bg-transparent outline-none text-[#948A78] text-[13px] uppercase tracking-[0.3em] placeholder-[#B5AC9E]"
                  />
                  <div className="border-b border-[#877D6F]"></div>
                </div>

                <div>
                  <input
                    type="tel"
                    placeholder="Mobile"
                    className="w-full bg-transparent outline-none text-[#948A78] text-[13px] uppercase tracking-[0.3em] placeholder-[#B5AC9E]"
                  />
                  <div className="border-b border-[#877D6F]"></div>
                </div>

                <div>
                  <input
                    type="email"
                    placeholder="Email ID"
                    className="w-full bg-transparent outline-none text-[#948A78] text-[13px] uppercase tracking-[0.3em] placeholder-[#B5AC9E]"
                  />
                  <div className="border-b border-[#877D6F]"></div>
                </div>

                <div>
                  <textarea
                    placeholder="Special Request"
                    className="w-full bg-transparent outline-none text-[#948A78] text-[13px] uppercase tracking-[0.3em] placeholder-[#B5AC9E]"
                  />
                  <div className="border-b border-[#877D6F] mt-20 mb-5"></div>
                </div>

                <button
                  onClick={() => setActiveStep(3)}
                  className="tracking-[0.25em] text-[13px] uppercase text-[#948A78] ml-40
                  hover:font-bold underline decoration-[#948A78] underline-offset-[10px] decoration-1 hover:underline-offset-[5px] transition-all duration-300"
                >
                  confirm&nbsp;&&nbsp;proceed
                </button>
              </div>
            </div>

            <div
              ref={addToRefs}
              data-step={2}
              className="flex flex-col items-center justify-center min-h-screen px-1 lg:hidden"
            >
              <div className="mb-2 text-right">
                <p className="text-[#948A78] text-[20px] sm:mr-[68vh] mr-60">
                  Payment
                  <br />
                  Details
                </p>
              </div>

              <div className="space-y-8 sm:w-[350px] w-[240px] ml-14">
                <div>
                  <select
                    defaultValue=""
                    className="w-full bg-transparent outline-none text-[#948A78] text-[13px] uppercase tracking-[0.3em] placeholder-[#B5AC9E]"
                  >
                    <option value="" disabled className="text-[#B5AC9E]">
                      Pay With
                    </option>
                    <option value="card">Credit / Debit Card</option>
                    <option value="upi">UPI</option>
                    <option value="netbanking">Net Banking</option>
                    <option value="cash">Cash</option>
                  </select>

                  <div className="border-b border-[#877D6F]"></div>
                </div>

                <div>
                  <input
                    type="tel"
                    placeholder="number"
                    className="w-full bg-transparent outline-none text-[#948A78] text-[13px] uppercase tracking-[0.3em] placeholder-[#B5AC9E]"
                  />
                  <div className="border-b border-[#877D6F]"></div>
                </div>

                <div>
                  <input
                    type="tel"
                    placeholder="Mobile"
                    className="w-full bg-transparent outline-none text-[#948A78] text-[13px] uppercase tracking-[0.3em] placeholder-[#B5AC9E]"
                  />
                  <div className="border-b border-[#877D6F]"></div>
                </div>

                <div>
                  <input
                    type="email"
                    placeholder="Email ID"
                    className="w-full bg-transparent outline-none text-[#948A78] text-[13px] uppercase tracking-[0.3em] placeholder-[#B5AC9E]"
                  />
                  <div className="border-b border-[#877D6F]"></div>
                </div>

                <div>
                  <textarea
                    placeholder="Special Request"
                    className="w-full bg-transparent outline-none text-[#948A78] text-[13px] uppercase tracking-[0.3em] placeholder-[#B5AC9E]"
                  />
                  <div className="border-b border-[#877D6F] mt-20 mb-5"></div>
                </div>

                <button
                  onClick={() => setActiveStep(3)}
                  className="tracking-[0.25em] text-[13px] uppercase text-[#948A78] hover:font-bold underline decoration-[#948A78] underline-offset-[12px] decoration-1 hover:underline-offset-[5px] transition-all duration-300 w-full text-left"
                >
                  confirm&nbsp;&&nbsp;proceed
                </button>
              </div>
            </div>

            <div ref={addToRefs} data-step={2} className="hidden lg:block">
              <p className="text-[#948A78] text-[20px] mb-6 text-right xl:mr-[70vh] lg:mr-[50vh]">
                Pricing <br /> Details
              </p>

              <div className="text-[13px] tracking-[0.2em] text-[#948A78] space-y-4 pl-32">
                <div className="grid grid-cols-2 w-[300px]">
                  <p>Rs xx × 1 night</p>
                  <p className="text-right">Rs xx</p>
                </div>

                <div className="grid grid-cols-2 w-[300px]">
                  <p>GST @ 12%</p>
                  <p className="text-right">Rs xx</p>
                </div>

                <div className="grid grid-cols-2 w-[300px]">
                  <p>Convenience Fee</p>
                  <p className="text-right">Rs xx</p>
                </div>

                <div className="pt-6">
                  <div className="grid grid-cols-2 w-[300px] uppercase font-bold tracking-[0.3em]">
                    <p>Total Cost</p>
                    <p className="text-right">Rs xx</p>
                  </div>

                  <p className="text-[13px] tracking-[0.25em] mt-8 xl:ml-[35vh] lg:ml-60 2xl:ml-60">
                    Rs&nbsp;xx
                    <br />
                    per&nbsp;person
                  </p>
                </div>
              </div>
            </div>

            <div
              ref={addToRefs}
              data-step={2}
              className="block lg:hidden text-left px-8"
            >
              <p className="text-[#948A78] text-[20px] mb-6 sm:ml-[15vh] -ml-[8vh]">
                Pricing
                <br />
                Details
              </p>

              <div className="text-[13px] tracking-[0.2em] text-[#948A78] space-y-4 ml-10">
                <div className="grid grid-cols-2 w-full max-w-xs mx-auto">
                  <p>Rs xx X 1 night</p>
                  <p className="text-right">Rs xx</p>
                </div>

                <div className="grid grid-cols-2 w-full max-w-xs mx-auto">
                  <p>GST @ 12%</p>
                  <p className="text-right">Rs xx</p>
                </div>

                <div className="grid grid-cols-2 w-full max-w-xs mx-auto">
                  <p>Convenience Fee</p>
                  <p className="text-right">Rs xx</p>
                </div>

                <div className="pt-6">
                  <div className="grid grid-cols-2 w-full max-w-xs mx-auto uppercase font-bold tracking-[0.3em]">
                    <p>Total Cost</p>
                    <p className="text-right">Rs xx</p>
                  </div>

                  <div className="grid grid-cols-2 w-full max-w-xs mx-auto mt-8">
                    <div />
                    <p className="justify-self-end text-[13px] -mr-10 tracking-[0.25em] text-[#948A78]">
                      Rs&nbsp;xx
                      <br />
                      per&nbsp;person
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ---------------- CONFIRMATION PAGE---------------- */}
      {activeStep === 3 && (
        <div className="max-w-[1400px] mx-auto px-6 lg:px-20">
          <div
            ref={addToRefs}
            data-step={3}
            className="grid grid-cols-1 lg:grid-cols-2 gap-10"
          >
            <div className="hidden lg:block mt-32 space-y-10 xl:px-24 lg:px-5">
              <div className="flex items-center justify-between">
                <p className="text-[#948A78] text-[20px]">Dates</p>
                <p className="text-[#948A78] tracking-[0.25em] uppercase text-[13px]">
                  3 September – 10 September
                </p>
              </div>

              <div className="flex items-center justify-between">
                <p className="text-[#948A78] text-[20px]">Guests</p>
                <p className="text-[#948A78] tracking-[0.25em] uppercase text-[13px] mr-44">
                  2&nbsp;Guests
                </p>
              </div>

              <div className="flex items-center justify-between pr-20">
                <p className="text-[#948A78] text-[20px]">Total Cost</p>
                <p className="text-[#948A78] tracking-[0.25em] uppercase text-[13px] mr-[20vh] 2xl:mr-[8vh]">
                  Rs&nbsp;xx
                </p>
              </div>
            </div>

            <div className="hidden lg:flex flex-col items-end">
              <img
                src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/feedbd35-5f4e-43a6-9d88-536119619600/public" //Tao_details.webp
                alt="img 3"
                className="w-[70vh] h-[50vh] xl:w-[80vh] xl:h-[60vh] 2xl:h-[45vh] object-cover"
              />

              <div className="bg-[#f5f2f0] py-10 px-10 mt-14 w-[70vh] xl:w-[80vh] 2xl:w-[70vh]">
                <p className="uppercase tracking-[0.35em] text-[#BFB5A3] text-[13px] mb-6 -ml-56">
                  Trip Confirmed
                </p>

                <p className="text-[#948A78] text-[20px] leading-relaxed -ml-10">
                  Congratulations, your trip with us is
                  <br />
                  booked with us!
                </p>

                <p className="text-[#948A78] text-[20px] mt-4 -ml-10">
                  We look forward to hosting you!
                </p>
              </div>
            </div>
          </div>

          <div className="lg:hidden mt-10">
            {/* Details */}
            <div
              ref={addToRefs}
              data-step={3}
              className="w-full flex justify-center mt-10"
            >
              <div className="bg-[#f5f2f0] py-10 px-8 w-full max-w-[450px]">
                <p className="uppercase tracking-[0.35em] text-[#BFB5A3] text-[12px] mb-4">
                  Trip Confirmed
                </p>

                <p className="text-[#948A78] text-[18px] leading-relaxed">
                  Congratulations, your trip with us is booked!
                </p>

                <p className="text-[#948A78] text-[18px] mt-4">
                  We look forward to hosting you!
                </p>
              </div>
            </div>

            <div
              ref={addToRefs}
              data-step={3}
              className="mt-32 space-y-6 px-10 sm:px-52"
            >
              <div className="flex justify-between pb-2">
                <p className="text-[#948A78] text-[18px]">Dates</p>
                <p className="text-[#948A78] tracking-[0.2em] text-[12px] uppercase">
                  3&nbsp;September&nbsp;To
                  <br />
                  10&nbsp;September
                </p>
              </div>

              <div className="flex justify-between pb-2">
                <p className="text-[#948A78] text-[18px]">Guests</p>
                <p className="text-[#948A78] tracking-[0.2em] text-[12px] uppercase">
                  2&nbsp;Guests
                </p>
              </div>

              <div className="flex justify-between pb-20">
                <p className="text-[#948A78] text-[18px]">
                  Total
                  <br />
                  Cost
                </p>
                <p className="text-[#948A78] tracking-[0.2em] text-[12px] uppercase">
                  Rs xx
                </p>
              </div>
            </div>

            <div className="-mx-6 lg:hidden">
              <img
                src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/feedbd35-5f4e-43a6-9d88-536119619600/public" //Tao_details.webp
                alt="Trip"
                className="w-screen h-[40vh] sm:h-[65vh] object-cover"
              />
            </div>
          </div>
        </div>
      )}

      <NewFooter />
    </div>
  );
};

export default Details;
